import { useStateMachine } from 'little-state-machine';

export const useFormState = (actions) => {
  return useStateMachine(actions);
};
